import { Form } from "antd"
import { Flex, Icon, Switch, Tag, Text } from "components/common"
import { t } from "i18next"
import { useAddSalesContext } from "features/leads/components/addSalesModal/addSalesContext/addSalesContext"
import { configs } from "configs"
import theme from "utils/themeVars"

function renderBuyerFeeLabel() {
  return (
    <Flex align="center" gap={"8px"} wrap="wrap" style={{ lineHeight: 1.3 }}>
      <Icon
        hasBackground
        style={{
          backgroundColor: "#E6E6E6",
          borderRadius: "1.2rem",
          margin: -8,
        }}
        icon="BsInfo"
        color="#707070"
        size="1.2rem"
        className="pointer"
        tooltipText={t("This indicates the fee was received directly in Bayut's bank account.")}
      />
      <Text className="gray-900">{t("Mark Payment as Bayut Service Fee")}</Text>
      <Tag color={theme["accent-color"]}>{t("New")}</Tag>
    </Flex>
  )
}

const BuyerFeeCheckbox = ({ listFieldName, disabled = false }) => {
  const { vasEnabled } = useAddSalesContext()
  const visible = vasEnabled && configs.showBuyerFeeCheckbox
  if (!visible) return null

  return (
    <Form.Item
      preserve
      name={[listFieldName, "buyerFee"]}
      valuePropName="checked"
      initialValue={false}
      colon={false}
      label={renderBuyerFeeLabel()}
      style={{ flex: "0 0 auto", marginBottom: 0, minWidth: 200, maxWidth: 320 }}
    >
      <Switch disabled={disabled} style={{ marginTop: "10px" }} />
    </Form.Item>
  )
}

export default BuyerFeeCheckbox
